import { merge, MonoTypeOperatorFunction, Observable } from 'rxjs'
import { debounceTime, share, skip, take } from 'rxjs/operators'

/**
 * Passes first value through pipe immediately, debounces all subsequent emissions
 */
export function gbDebounceAfterFirst<T>(dueTime: number): MonoTypeOperatorFunction<T> {
  return (source$: Observable<T>) => {
    const multicasted$ = source$.pipe(share())
    return merge(multicasted$.pipe(take(1)), multicasted$.pipe(skip(1), debounceTime(dueTime)))
  }
}
